"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var DocumentCardLocation_base_1 = require("./DocumentCardLocation.base");
var DocumentCardLocation_styles_1 = require("./DocumentCardLocation.styles");
exports.DocumentCardLocation = Utilities_1.styled(DocumentCardLocation_base_1.DocumentCardLocationBase, DocumentCardLocation_styles_1.getStyles, undefined, { scope: 'DocumentCardLocation' });
//# sourceMappingURL=DocumentCardLocation.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/DocumentCard/DocumentCardLocation.js
// module id = 958
// module chunks = 0